import { createApp } from 'vue';
import PictToAvifConverter from '../Components/PictToAvifConverter.vue';

createApp(PictToAvifConverter).mount('#pict-to-avif-converter');
